module.exports = __webpack_public_path__ + "static/media/link_icon.6d85a126.svg";